import React from 'react';
import { SmartActionsInput } from './ChatInput';
import { WidgetChatInput } from './WidgetChatInput';
import DefaultInputContainer from './default-components/DefaultInputContainer';

interface EnhancedChatInputProps {
  isWidgetChat: boolean;
  input: string;
  handleInputChange: (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>,
  ) => void;
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  isInProgress: boolean;
  generalBackground?: string;
  borderColor?: string;
  textColor?: string;
  buttonColor?: string;
  options?: {
    agentName?: string;
    agentImage?: string;
    placeholderText?: string;
    customComponents?: {
      mobileInputExtraButton?: React.ReactNode;
      sendButtonComponent?: React.ComponentType<any>;
      inputContainer?: React.ComponentType<any>;
    };
  };
}

export const EnhancedChatInput: React.FC<EnhancedChatInputProps> = ({
  isWidgetChat,
  input,
  handleInputChange,
  handleSubmit,
  isInProgress,
  generalBackground,
  borderColor,
  textColor,
  buttonColor,
  options,
}) => {
  const InputContainer =
    options?.customComponents?.inputContainer || DefaultInputContainer;

  const handleSubmitChat = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleSubmit(e);
  };

  if (isWidgetChat) {
    return (
      <div className="bitte-pb-2 bitte-px-4 bitte-w-full">
        <WidgetChatInput
          input={input}
          handleChange={handleInputChange}
          agentImage={options?.agentImage}
          handleSubmit={handleSubmitChat}
          isLoading={isInProgress}
          agentName={options?.agentName || ''}
          buttonColor={buttonColor || '#000000'}
          borderColor={borderColor || '#334155'}
          textColor={textColor || '#ffffff'}
          backgroundColor={generalBackground || '#0A0A0C'}
          autoFocus
        />
      </div>
    );
  }

  return (
    <InputContainer
      style={{
        backgroundColor: generalBackground,
        borderColor: borderColor,
      }}
    >
      <SmartActionsInput
        input={input}
        handleChange={handleInputChange}
        handleSubmit={handleSubmitChat}
        isLoading={isInProgress}
        buttonColor={buttonColor || ''}
        agentImage={options?.agentImage}
        borderColor={borderColor || ''}
        textColor={textColor || ''}
        backgroundColor={generalBackground || ''}
        agentName={options?.agentName}
        mobileInputExtraButton={
          options?.customComponents?.mobileInputExtraButton as
            | React.ReactElement
            | undefined
        }
        customSendButtonComponent={
          options?.customComponents?.sendButtonComponent
        }
        placeholderText={options?.placeholderText}
      />
    </InputContainer>
  );
};
